<template>
  <div>
    <div style="margin-bottom: 20px">
      <el-button type="danger" @click="hint">新 增</el-button>
      <el-input v-model="tableQuery.name" style="width: 200px;margin: 0 10px" placeholder="请输入名称"></el-input>
      <el-button :loading="tableQuery.tableLoading" type="danger" @click="selectTable">搜 索</el-button>
      <el-button type="danger" @click="hint">批量导出</el-button>
    </div>
    <el-table :data="tableData" class="table" height="626px" border v-loading="tableQuery.tableLoading">
      <el-table-column prop="name" label="名称"/>
      <el-table-column prop="describe" label="报表描述"/>
      <el-table-column prop="updateName" label="修改用户"/>
      <el-table-column prop="updateDate" label="修改时间"/>
      <el-table-column label="操作" width="160" align="center">
        <template #default="scope">
          <div>
            <el-button type="text" size="small" @click.prevent="toDetail(scope.row)">查看</el-button>
            <el-button type="text" size="small" style="margin:0 16px" @click.prevent="hint(scope.row)">编辑</el-button>
            <el-popconfirm title="确定要删除该班次吗？" @confirm="hint(scope.row.id)">
              <el-button slot="reference" type="text" size="small" style="color: red;">删除</el-button>
            </el-popconfirm>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        style="text-align: right;margin: 20px 10px"
        :page-sizes="[100, 200, 300, 400]"
        :page-size="10"
        @current-change="changePage"
        layout="total, prev, pager, next, jumper"
        :total="tableQuery.tableTotal">
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: "Statement",
  data() {
    return {
      tableData:[
          {name:"月度汇总",describe:"",updateName:"",updateDate:"",url:"/admin/attendance/statistics/statementDetail"},
          {name:"打卡时间",describe:"",updateName:"",updateDate:"",url:"/admin/attendance/statistics/clockInTime"},
          {name:"每日统计",describe:"",updateName:"",updateDate:"",url:"/admin/attendance/statistics/dayStatistics"},
          {name:"原始记录",describe:"",updateName:"",updateDate:"",url:"/admin/attendance/statistics/originalRecord"},
      ],
      tableQuery:{
        tableLoading:false,
        tableTotal:0
      },

    }
  },
  methods:{
    changePage(){

    },
    selectTable(){
      this.tableQuery.tableLoading = true;
      setTimeout(() => {
        this.tableQuery.tableLoading = false;
      }, 1000);
    },
    toDetail(val){
      this.$router.push({
        path: val.url,
        query: {item:val}
      });
    },
    hint(){
      this.$message.warning('开发中');
    },
  }
}
</script>

<style scoped>
.table{
  width: 100%;
  border-radius: 10px;
  padding: 6px 0px 10px 6px;
}
</style>